import React, {useCallback, useEffect, useState} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import { getActivitiesDetail,activitiesEnroll } from "../../service";
import { ActivityDetailData } from "../types";
import ImageBox from "../../components/Image";
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";
import useUserInfo from "../../routers/useUserInfo";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useModal} from "../../components/modal";


interface ActMatch {
    actId: string,
}

const ActDetail = () => {

    const { actId } = useParams<ActMatch>();
    const [detail,setDetail] = useState<ActivityDetailData>()
    const [cover,setCover] = useState<boolean>(false)
    const userData = useUserInfo(false)
    const phones = usePhones()
    const loading = useLoading()
    const modal = useModal()
    const { push } = useHistory()

    useEffect(() => {
        getActivitiesDetail({
            activityId:actId
        }).then(res => {
            if(res.code === 1){
                setDetail(res.data)
            }
        })

    },[actId])

    const SubmitHandle = useCallback(() => {
        if(userData){
            activitiesEnroll({
                userId:userData.id,
                activityId:actId
            }).then(res => {
                if(res.code === 1){
                    modal.show({
                        content:'你已报名成功，请在 [个人中心-> 社群活动] 下查看',
                        success:(res) => {
                            if(res.confirm){
                                push('/user')
                            }
                        }
                    })
                }else{
                    loading.showError(res.msg)
                }
            })
        }else {
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }

    },[actId])

    return <div className="act-detail">
        <ImageBox src={ detail?.coverUrl } height={ 53.5 }/>
        <div className="top">
            <h3>{ detail?.activityTitle }</h3>
            <p className="d"> <span className='iconfont'>&#xe616;</span> 活动时间：{ detail?.startTime } ~ { detail?.endTime }</p>
            <p className="d"> <span className="iconfont">&#xe728;</span> 活动地点：{ detail?.address }</p>
            <div className="rules">
                <p>{ detail?.threshold }
                </p>
            </div>
        </div>
        <div className="space"/>
        <div className="content">
            <h2 className="d-title"><span className='iconfont'>&#xe64f;</span> 活动详情</h2>
            <div className="text" dangerouslySetInnerHTML={{ __html:detail ? detail.activityContent : '' }}/>
        </div>
        {
            detail && <div className="fixed-space" style={{height: '1rem'}}>
                <div className="common-fixed">
                    <div className="common-btn" onClick={() => setCover(true)}>
                        <p className="iconfont">&#xe62e;</p>
                        <p>我要咨询</p>
                    </div>
                    {
                        detail.statusCode === 1 &&  <div onClick={ SubmitHandle } className="common-btn">立即报名</div>
                    }

                </div>
            </div>
        }
        <MakePhoneCall show={ cover } telephone={ phones[5] } onClose={() => setCover(false)}/>
    </div>
}

export default ActDetail;
